import React from 'react';
const AddContext = React.createContext({
    isAddMode: false,
    isRoot: true,
    setAddMode: () => true,
    resetAddMode: () => false,
});
export default AddContext;
